import React from 'react'
import { ProviderRoleId } from '../../currentRole'
import CarePlanBody from './CarePlanBody'

type Props = { role: ProviderRoleId }

const CarePlanEditor = ({ role }: Props) => <CarePlanBody role={role} readOnly={false} />

export default CarePlanEditor
